module.exports = __webpack_public_path__ + "media/images/arrows/green-right-bf481b6e52b3211b258dc5f44b68017f.svg";